function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.778 15.222a10.958 10.958 0 0 0-4.18-2.622 6.357 6.357 0 0 0 2.761-5.24A6.367 6.367 0 0 0 12 1a6.367 6.367 0 0 0-6.36 6.36 6.357 6.357 0 0 0 2.762 5.24 10.958 10.958 0 0 0-4.18 2.622A10.928 10.928 0 0 0 1 23h1.719c0-5.118 4.163-9.281 9.281-9.281s9.281 4.163 9.281 9.281H23c0-2.938-1.144-5.7-3.222-7.778zM12 12a4.646 4.646 0 0 1-4.64-4.64A4.646 4.646 0 0 1 12 2.718a4.646 4.646 0 0 1 4.64 4.64A4.646 4.646 0 0 1 12 12z"
});

var SvgIcPerson = function SvgIcPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_person.1ed8e796.svg";
export { ForwardRef as ReactComponent };